// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { useEffect, useRef, useCallback } from 'react';
function isInsideRefs(target, refs) {
    return refs.some((ref) => { var _a; return ((_a = ref.current) === null || _a === void 0 ? void 0 : _a.contains(target)) === true; });
}
export function usePopover({ ref: menuRef, excludeRefs = [], onOutsideClick, isPinned = false }) {
    const excludeRefsRef = useRef(excludeRefs);
    excludeRefsRef.current = excludeRefs;
    useEffect(() => {
        if (isPinned || onOutsideClick === undefined) {
            return;
        }
        const handleOutsideClick = (event) => {
            const target = event.target;
            if (target === null) {
                return;
            }
            const menuElement = menuRef.current;
            const isClickInsideMenu = (menuElement === null || menuElement === void 0 ? void 0 : menuElement.contains(target)) === true;
            const isClickOnExcluded = isInsideRefs(target, excludeRefsRef.current);
            if (!isClickInsideMenu && !isClickOnExcluded) {
                onOutsideClick(event);
            }
        };
        document.addEventListener('mousedown', handleOutsideClick);
        return () => {
            document.removeEventListener('mousedown', handleOutsideClick);
        };
    }, [menuRef, onOutsideClick, isPinned]);
    const getPopoverStyle = useCallback(({ top, left, minWidth, maxWidth, minHeight, maxHeight }) => (Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({ position: 'fixed' }, (minWidth > 0 && { minWidth: `${minWidth}px` })), (maxWidth > 0 && { maxWidth: `${maxWidth}px` })), (minHeight > 0 && { minHeight: `${minHeight}px` })), (maxHeight > 0 && { maxHeight: `${maxHeight}px` })), (top !== undefined && { top: `${top}px` })), (left !== undefined && { left: `${left}px` }))), []);
    return { getPopoverStyle };
}
